module.exports = __webpack_public_path__ + "img/dark-narrow-street.b3b4bb60.jpg";